export default __webpack_public_path__ + "static/media/blue_blue_white.673d8f76.svg";